import styled from "styled-components";

const FirmType = styled.p`
  margin: 0;
`;

export default FirmType;
